import React from 'react';
import { Building, LogOut, Package, Store, Users } from 'lucide-react';

import { useAuth } from '../contexts/AuthContext';
import DesktopReleasesTab from '../components/admin/DesktopReleasesTab';
import UserManagementTab from '../components/admin/UserManagementTab';
import TenantsTab from '../components/admin/TenantsTab';
import { Button } from '../components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';

const SuperAdminDashboard = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-red-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-xl border-b border-orange-100 sticky top-0 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl flex items-center justify-center">
                <Building className="w-6 h-6 text-white" />
              </div>
              <div>
                <h1 className="text-xl sm:text-2xl font-bold text-gray-800">Panel Super Admin</h1>
                <p className="text-xs sm:text-sm text-gray-600">{user?.name}</p>
              </div>
            </div>
            <Button
              onClick={logout}
              variant="outline"
              data-testid="logout-button"
              className="border-orange-200 hover:bg-orange-50 rounded-xl"
            >
              <LogOut className="w-4 h-4 sm:mr-2" />
              <span className="hidden sm:inline">Cerrar Sesión</span>
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Tabs for Restaurants and Users */}
        <Tabs defaultValue="tenants" className="space-y-6">
          <TabsList className="grid grid-cols-3 gap-2 bg-white/80 backdrop-blur-xl p-2 rounded-2xl border border-orange-100">
            <TabsTrigger value="tenants" className="rounded-xl data-[state=active]:bg-gradient-to-r data-[state=active]:from-orange-500 data-[state=active]:to-red-500 data-[state=active]:text-white">
              <Store className="w-4 h-4 mr-2" />
              Restaurantes
            </TabsTrigger>
            <TabsTrigger value="users" className="rounded-xl data-[state=active]:bg-gradient-to-r data-[state=active]:from-orange-500 data-[state=active]:to-red-500 data-[state=active]:text-white">
              <Users className="w-4 h-4 mr-2" />
              Usuarios
            </TabsTrigger>
            <TabsTrigger value="desktop" className="rounded-xl data-[state=active]:bg-gradient-to-r data-[state=active]:from-orange-500 data-[state=active]:to-red-500 data-[state=active]:text-white">
              <Package className="w-4 h-4 mr-2" />
              Desktop
            </TabsTrigger>
          </TabsList>

          <TabsContent value="tenants">
            <TenantsTab />
          </TabsContent>

          <TabsContent value="users">
            <UserManagementTab />
          </TabsContent>

          <TabsContent value="desktop">
            <DesktopReleasesTab />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default SuperAdminDashboard;
